// extracted by mini-css-extract-plugin
module.exports = {"viewport":"v21uVMGivAPzkIxc3plb0g=="};